import { vendorPlaceholderDark } from '@/assets/images'
import { useTranslate } from '@/i18n/useTranslate'
import type { VendorBonusClaim } from '@/types/pos/depositBonus'
import {
    formatPromotionTotalAmount,
    hasLaterBonusSteps,
    isClaimedBonusStep,
    isNextBonusStep
} from '@/utilities/depositBonusHelper'

type VendorBonusProgressBannerProps = {
    claim: VendorBonusClaim
}

export default function VendorBonusProgressBanner({
    claim
}: VendorBonusProgressBannerProps) {
    const { t } = useTranslate()
    const showUnlockHint = hasLaterBonusSteps(
        claim.steps,
        claim.depositOrdinal
    )

    return (
        <div className="vendor-bonus-progress-banner">
            <div className="vendor-bonus-progress-banner__brand">
                <div className="vendor-bonus-progress-banner__logo">
                    <img
                        src={claim.vendorLogoUrl || vendorPlaceholderDark}
                        alt=""
                    />
                </div>
                <span className="vendor-bonus-progress-banner__promo">
                    {t('vendorBonusBanner.promo')}
                </span>
            </div>

            <div className="vendor-bonus-progress-banner__copy">
                <p>
                    {t('vendorBonusBanner.activeBonus', {
                        ordinal: claim.depositOrdinal
                    })}
                </p>
                <strong>
                    +{formatPromotionTotalAmount(claim.rewardAmount)}{' '}
                    {claim.currencyCode}
                </strong>
                {showUnlockHint ? (
                    <span>{t('vendorBonusBanner.unlockMore')}</span>
                ) : null}
            </div>

            <ol className="vendor-bonus-progress-banner__steps">
                {claim.steps.map((step) => {
                    const isActive = isNextBonusStep(step.status)
                    const isClaimed = isClaimedBonusStep(step.status)
                    const stateClass = isActive
                        ? 'vendor-bonus-progress-banner__step--active'
                        : isClaimed
                          ? 'vendor-bonus-progress-banner__step--claimed'
                          : 'vendor-bonus-progress-banner__step--upcoming'

                    return (
                        <li
                            key={step.depositOrdinal}
                            className={`vendor-bonus-progress-banner__step ${stateClass}`}>
                            <span className="vendor-bonus-progress-banner__marker">
                                {isClaimed ? '✓' : step.depositOrdinal}
                            </span>
                            <div className="vendor-bonus-progress-banner__step-card">
                                <span>
                                    {t('vendorBonusBanner.stepDeposit', {
                                        ordinal: step.depositOrdinal
                                    })}
                                </span>
                                <strong>
                                    {formatPromotionTotalAmount(step.amount)}{' '}
                                    {step.currencyCode || claim.currencyCode}
                                </strong>
                            </div>
                        </li>
                    )
                })}
            </ol>

            <span
                className="vendor-bonus-progress-banner__check"
                aria-hidden="true">
                ✓
            </span>
        </div>
    )
}
